export default __webpack_public_path__ + "static/media/home-decor-img-01.bf9f1b2a.jpg";